<div class="row">
    <div class="col-md-3 col-12">
        <div class="card">
            <div class="card-header">
                <div class="card-title">User Permission</div>
            </div>
            <div class="card-body">
                <table class="table table-striped table-sm">
                    <tbody>
                        <tr><th>Name</th><td>{{data.name}}</td></tr>
                        <tr><th>Username</th><td>{{data.username}}</td></tr>

                        <tr *ngIf="is_mario || user_permission.can_view"><th>Can View</th><td>
                            <select [(ngModel)]="data.can_view">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.can_manage"><th>Can Manage</th><td>
                            <select [(ngModel)]="data.can_manage">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        
                        <tr *ngIf="is_mario || user_permission.can_search"><th>Can Search</th><td>
                            <select [(ngModel)]="data.can_search">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.can_report"><th>Can Report</th><td>
                            <select [(ngModel)]="data.can_report">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.can_adjust"><th>Can Adjust</th><td>
                            <select [(ngModel)]="data.can_adjust">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.can_adjust2"><th>Can Adjust 2</th><td>
                            <select [(ngModel)]="data.can_adjust2">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.adjust_app"><th>Manage App Setting</th><td>
                            <select [(ngModel)]="data.adjust_app">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.show_number"><th>Show Number</th><td>
                            <select [(ngModel)]="data.show_number">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.can_export"><th>Can Export</th><td>
                            <select [(ngModel)]="data.can_export">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.voucher"><th>Show Voucher</th><td>
                            <select [(ngModel)]="data.voucher">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.game_integration"><th>Game Integration</th><td>
                            <select [(ngModel)]="data.game_integration">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.summary_report"><th>Summary Report</th><td>
                            <select [(ngModel)]="data.summary_report">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.edit_summary_report"><th>Edit Summary Report</th><td>
                            <select [(ngModel)]="data.edit_summary_report">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.daily_report"><th>Daily Report</th><td>
                            <select [(ngModel)]="data.daily_report">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.edit_daily_report"><th>Edit Daily Report</th><td>
                            <select [(ngModel)]="data.edit_daily_report">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.expenses"><th>Expenses</th><td>
                            <select [(ngModel)]="data.expenses">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>
                        <tr *ngIf="is_mario || user_permission.edit_expenses"><th>Edit Expenses</th><td>
                            <select [(ngModel)]="data.edit_expenses">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                        </td></tr>

                        <tr><th>Status</th><td>
                            <select [(ngModel)]="data.status">
                                <option [value]="0">Disabled</option>
                                <option [value]="1">Active</option>
                            </select>
                        </td></tr>
                        <tr>
                            <td colspan="2">
                                <button class="btn btn-primary" (click)="update()">Update</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>